import 'codemirror/addon/display/placeholder';
import 'codemirror/addon/display/rulers';
import 'codemirror/addon/scroll/simplescrollbars';
import 'codemirror/addon/selection/mark-selection';
import 'codemirror/addon/selection/active-line';
import 'codemirror/mode/htmlembedded/htmlembedded';
import 'codemirror/mode/htmlmixed/htmlmixed';
import 'codemirror/mode/spreadsheet/spreadsheet';

